import React from "react";
import fscreen from "fscreen";

export default function useFullscreen(elRef) {
  const [inFullscreenMode, setInFullscreenMode] = React.useState(false);

  const handleFullscreenChange = React.useCallback((e) => {
    let change = "";
    if (fscreen.fullscreenElement !== null) {
      change = "Entered fullscreen mode";
      setInFullscreenMode(true);
      let divs = document.querySelectorAll("div#root > div");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "hidden";
      }
      if (document.querySelectorAll("[id*='b_drjhr00d_']").length !== 0) {
        document.querySelectorAll("[id*='b_drjhr00d_']")[0].style.visibility =
          "hidden";
      }
    } else {
      change = "Exited fullscreen mode";
      setInFullscreenMode(false);
      let divs = document.querySelectorAll("div#root > div");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "visible";
      }
      if (document.querySelectorAll("[id*='b_drjhr00d_']").length !== 0) {
        document.querySelectorAll("[id*='b_drjhr00d_']")[0].style.visibility =
          "hidden";
      }
    }
    console.log(change, e);
  }, []);

  const handleFullscreenError = React.useCallback((e) => {
    console.log("Fullscreen Error", e);
  }, []);

  React.useEffect(() => {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener(
        "fullscreenchange",
        handleFullscreenChange,
        false
      );
      fscreen.addEventListener("fullscreenerror", handleFullscreenError, false);
      return () => {
        fscreen.removeEventListener("fullscreenchange", handleFullscreenChange);
        fscreen.removeEventListener("fullscreenerror", handleFullscreenError);
      };
    }
  });

  const toggleFullscreen = React.useCallback(() => {
    if (inFullscreenMode) {
      fscreen.exitFullscreen();
    } else {
      fscreen.requestFullscreen(elRef.current);
    }
  }, [inFullscreenMode]);

  return [toggleFullscreen, inFullscreenMode];
}
